import { EnumSelect } from "@/components/shared/enum-select";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  SALES_ORDER_CUSTOMER_OPTIONS,
  SALES_ORDER_ITEM_OPTIONS,
  SALES_ORDER_STATUS_OPTIONS,
  type SalesOrderSearchFilters,
} from "@/mocks/search-sales-orders";

interface SearchFiltersPanelProps {
  values: SalesOrderSearchFilters;
  onChange: (values: SalesOrderSearchFilters) => void;
  onSearch: () => void;
}

export function SearchFiltersPanel({ values, onChange, onSearch }: SearchFiltersPanelProps) {
  function set<K extends keyof SalesOrderSearchFilters>(key: K, value: SalesOrderSearchFilters[K]) {
    onChange({ ...values, [key]: value });
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Search</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div className="grid gap-1.5">
            <Label htmlFor="so-order-no">Order No</Label>
            <Input
              id="so-order-no"
              placeholder="e.g. SO-1048"
              value={values.orderNo}
              onChange={(e) => set("orderNo", e.target.value)}
            />
          </div>
          <div className="grid gap-1.5">
            <Label>Customer</Label>
            <EnumSelect
              value={values.customer}
              onValueChange={(v) => set("customer", v)}
              options={SALES_ORDER_CUSTOMER_OPTIONS}
              allOption={{ label: "Any customer" }}
              aria-label="Customer"
            />
          </div>
          <div className="grid gap-1.5">
            <Label>Status</Label>
            <EnumSelect
              value={values.status}
              onValueChange={(v) => set("status", v)}
              options={SALES_ORDER_STATUS_OPTIONS}
              allOption={{ label: "Any status" }}
              aria-label="Status"
            />
          </div>
          <div className="grid gap-1.5">
            <Label>Item</Label>
            <EnumSelect
              value={values.itemCode}
              onValueChange={(v) => set("itemCode", v)}
              options={SALES_ORDER_ITEM_OPTIONS}
              allOption={{ label: "Any item" }}
              aria-label="Item"
            />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="so-order-date-from">Order date from</Label>
            <Input
              id="so-order-date-from"
              type="date"
              value={values.orderDateFrom}
              onChange={(e) => set("orderDateFrom", e.target.value)}
            />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="so-order-date-to">Order date to</Label>
            <Input
              id="so-order-date-to"
              type="date"
              value={values.orderDateTo}
              onChange={(e) => set("orderDateTo", e.target.value)}
            />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="so-ship-date-from">Ship date from</Label>
            <Input
              id="so-ship-date-from"
              type="date"
              value={values.shipDateFrom}
              onChange={(e) => set("shipDateFrom", e.target.value)}
            />
          </div>
          <div className="grid gap-1.5">
            <Label htmlFor="so-ship-date-to">Ship date to</Label>
            <Input
              id="so-ship-date-to"
              type="date"
              value={values.shipDateTo}
              onChange={(e) => set("shipDateTo", e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <Button type="button" onClick={onSearch}>
            Search
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
